import { stylesheet } from "typestyle";

const styles = stylesheet({
  inputIcon: { width: "24px" },
});

export default styles;
